module.exports = __webpack_public_path__ + "static/img/360.e70faf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360.png
// module id = tVXk
// module chunks = 0